// extracted by mini-css-extract-plugin
export default {"headline":"modal_headline__aQIsR","spinner":"modal_spinner__S8x9E","buttonWrapper":"modal_buttonWrapper__VbFRA"};